import styled, { keyframes } from 'styled-components';
import {
    BACKGROUND_DEEP,
    CONTENT_BASE,
    PRIMARY_BASE,
    PRIMARY_TEXT_LINK_BASE,
    PRIMARY_TEXT_LINK_HOVER,
    PRIMARY_TEXT_LINK_PRESS,
} from '@amzn/ring-common-style-library/lib/colors';
import {
    BODY_NORMAL_LIGHT,
    BODY_NORMAL_MEDIUM,
    HEADING_NORMAL_MEDIUM,
} from '@amzn/ring-common-style-library/lib/typography';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const CloseIcon = styled.div`
    display: flex;
    align-self: flex-start;
    width: 24px;
    height: 24px;

    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    margin: auto;
    align-items: left;
    position: relative;

    animation: ${fadeIn} 1s ease-in-out;
`;

const Icon = styled.div`
    display: flex;
    width: 40px;
    height: 24px;
    /* per figma design logo is slightly off center */
    margin-top: 2px;
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    /* background is the new "Ring Blue" regardless of dark/light theme */
    background-color: #007ACC;
    border-radius: 8px;
    padding: 4px;
`;

const Subtitle = styled.div`
    ${BODY_NORMAL_LIGHT};
    color: ${CONTENT_BASE};
    text-align: left;
    word-break: break-word;

    margin-right: 4px;

    a {
        ${BODY_NORMAL_MEDIUM};
        color: ${PRIMARY_TEXT_LINK_BASE};

        &:hover {
            color: ${PRIMARY_TEXT_LINK_HOVER};
        }

        &:active {
            color: ${PRIMARY_TEXT_LINK_PRESS};
        }
    }
`;

const StartButton = styled.div`
    width: 100%;
`;

const Title = styled.div`
    ${HEADING_NORMAL_MEDIUM};
    color: ${CONTENT_BASE};

    text-align: left;
    margin-bottom: -16px;
`;

const Widget = styled.div`
    display: flex;
    flex: 1 1 auto;

    background: ${BACKGROUND_DEEP};
    padding: 16px;
    padding-bottom: 66px;
`;

export default {
    CloseIcon,
    ContentWrapper,
    Icon,
    IconWrapper,
    Subtitle,
    StartButton,
    Title,
    Widget,
};
